var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 432 432",
    style: {
      enableBackground: "new 0 0 432 432"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "GM_Gradient_Brandmark"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 216,
    y1: 2,
    x2: 216,
    y2: 434,
    gradientTransform: "matrix(1 0 0 -1 0 434)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0B8BD2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4EE0FD"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M432,61.6C432,24.2,407.8,0,370.4,0H61.6C24.3,0,0,24.2,0,61.6v308.8C0,407.8,24.2,432,61.6,432h308.8 c37.4,0,61.6-24.2,61.6-61.6V61.6z M367.5,404.6h-303c-24.5,0-37.1-12.6-37.1-37.1V64.5C27.4,40,40,27.4,64.5,27.4h303 c24.5,0,37.1,12.6,37.1,37.1v303.1C404.6,392,392,404.6,367.5,404.6L367.5,404.6z M352,147.2v114.5h-31.5V151.8 c0-7.6-5-12.5-12.4-12.5h-17.8v122.4h-31.5V139.2h-30.2v122.4h-31.5V111.9h119.6C338.7,111.9,352,125.5,352,147.2z M173.2,111.9 v155.8c0,18.3-8.2,52.3-61.7,52.3H98.3v-27.6h13.2c21-0.4,29.8-9.2,30.1-24.5v-6.3h-26.3c-20.9,0-35.3-14.1-35.3-35.3v-79.2 c0-21.1,14-35.3,35.3-35.3H173.2z M141.7,139.2H124c-7.4,0-12.5,5.2-12.5,12.4v69.9c0,7.6,5.3,12.7,12.8,12.7h17.4V139.2z  M197.1,320.1H352v-27.6H197.1V320.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGm);
export default __webpack_public_path__ + "static/media/GM.8c91f347.svg";
export { ForwardRef as ReactComponent };